/* import __COLOCATED_TEMPLATE__ from './data-section.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type FileSourceContent from 'embercom/models/file-source-content';
import { EntityType } from 'embercom/models/data/entity-types';

interface Args {
  activeContent: FileSourceContent;
}

export default class DataSection extends Component<Args> {
  get content() {
    return this.args.activeContent;
  }

  get isFromFileSource() {
    return this.content.sourceType === EntityType.FileSourceContent;
  }

  @action async setLocale(languageCode: string): Promise<void> {
    await this.content.updateLanguageCode(languageCode);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ContentEditor::Pdf::DataSection': typeof DataSection;
    'knowledge-hub/content-editor/pdf/data-section': typeof DataSection;
  }
}
